import { render, staticRenderFns } from "./BestProductsPage.vue?vue&type=template&id=48bdc9e9&scoped=true&"
import script from "./BestProductsPage.vue?vue&type=script&lang=js&"
export * from "./BestProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./BestProductsPage.vue?vue&type=style&index=0&id=48bdc9e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdc9e9",
  null
  
)

export default component.exports